









































import { Component } from 'vue-property-decorator';
import HomeSection from './Section.abstract';

@Component
export default class HomeIntroduction extends HomeSection {
  imagesAppeareence = true;

  textsAppearence = true;

  headersAppearence = true;

  imagesRefs = {
    childrend: 'children',
  };

  textsRefs = {
    text: 'text',
  };

  headersRefs = {
    header: 'header',
  };
}
